<template>
  <RfDialog
    ref="domainChooseDialog"
    title="Choose Domain"
    width="500"
    confirmText="Open"
    @confirm="open"
    @close="() => (closeChores(), emit('close'))"
  >
    <div class="flex flex-col items-start gap-5">
      <RfRadioGroup v-model="form.domain" vertical :options="domains" />
      <RfInput
        v-model.trim="form.path"
        name="path"
        title="Path"
        placeholder="/account"
        hintMessage="Optional path that gets appended to selected domain above"
        variant="outlined"
        class="w-full"
      />
      <RfSwitch v-if="liveV2" v-model="form.debug" title="Debug mode" class="flex-row-reverse" />
    </div>
  </RfDialog>
</template>

<script setup>
import RfInput from "@/components/inputs/RfInput.vue";
import RfRadioGroup from "@/components/inputs/RfRadioGroup.vue";
import RfSwitch from "@/components/inputs/RfSwitch.vue";
import RfDialog from "@/components/modals/RfDialog.vue";
import { useAppsStore } from "@/pinia/appsStore";
import { reactive, ref } from "vue";
import { useTemplateRef } from "vue";

const emit = defineEmits(["open", "close"]);

const appsStore = useAppsStore();
const domainChooseDialog = useTemplateRef("domainChooseDialog");
const form = reactive({
  domain: null,
  debug: false,
  path: "",
});
const domains = ref([]);
const liveV2 = ref(false);

const open = () => {
  const domain = getDomain();
  emit("open", domain);
};

defineExpose({
  open: (
    { domain, domainAliases, liveV2: liveV2In = false } = {
      domain: null,
      domainAliases: [],
      liveV2: false,
    },
  ) => {
    if (!domain) {
      domain = appsStore.app?.domain || "";
      domainAliases = appsStore.app?.domain_aliases || [];
      liveV2In = appsStore.app?.feature_set?.includes("live_v2") || false;
    }
    domains.value = [
      { label: domain, value: domain },
      ...domainAliases.map(a => ({ label: a, value: a })),
    ];
    form.domain = domain;
    liveV2.value = liveV2In;
    domainChooseDialog.value?.open();
  },
  close: () => domainChooseDialog.value?.close(),
});

const closeChores = () => {
  form.domain = null;
  form.debug = false;
  form.path = "";
  domains.value = [];
  liveV2.value = false;
};

const getDomain = () => {
  let { domain, path, debug } = form;

  if (path && !path.match(/^\//)) path = `/${path}`;

  if (path) domain += path;
  // debug flag to support existing conduit based live tool
  if (liveV2.value && debug) domain += `?debug=${debug}`;

  return domain;
};
</script>
